<template lang="html">
  <v-container fluid grid-list-lg>
    <v-row row wrap>
      <v-col xs12 class="pa-5">
        <h1>Unread Messages</h1>
        <v-btn @click="markAllAsRead()">Mark all as read</v-btn>
        <v-progress-linear
          v-if="show_mark_all_as_read_progress"
          color="teal"
          buffer-value="0"
          :value="mark_all_as_read_progress"
          stream
        ></v-progress-linear>

        <v-list>
          <v-list-item
            v-for="message in getMessagesCurrentUser"
            :key="message.id"
          >
            <v-list-item-action>
              <v-btn small @click="readMessageAndRoute(message)">Mark as Read and Route</v-btn>
              <v-icon v-if="message.type === 'notification'">notifications</v-icon>
              <v-icon v-if="message.type === 'warning'">warning</v-icon>
            </v-list-item-action>
            <v-list-item-title class="message-preview" style="margin-left: -25px">{{ message.text }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
    <v-row row wrap>
      <v-col xs12 class="pa-5">
        <h1>Read Messages</h1>
        <v-list>
          <v-list-item
            v-for="message in getReadMessagesCurrentUser"
            :key="'read'+message.id"
          >
            <v-list-item-action>
              <v-btn small @click="routeToMessage(message)">Route </v-btn>
              <v-icon v-if="message.type === 'notification'">notifications</v-icon>
              <v-icon v-if="message.type === 'warning'">warning</v-icon>
            </v-list-item-action>
            <v-list-item-title class="message-preview" style="margin-left: -25px">{{ message.text }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  mapActions,
  mapGetters
} from 'vuex';
export default {
  name: 'AccountMessages',
  data: function() {
    return {
      show_mark_all_as_read_progress: false,
      mark_all_as_read_progress: 0,
    }
  },
  created(){
    this.requestMessagesCurrentUser();
    this.requestOldMessagesCurrentUser();
  },
  computed: {
    ...mapGetters('Message', [
      'getMessagesCurrentUser',
      'getReadMessagesCurrentUser'
    ]),
    ...mapGetters('Auth', [
      'getUser'
    ]),
  },
  methods: {
    ...mapActions('User', [
      'updateUser',
      'userImageUpload'
    ]),
    ...mapActions('Message', [
      'requestMarkMessageAsRead',
      'requestMessagesCurrentUser',
      'requestOldMessagesCurrentUser',
    ]),
    getMessageRoute(msg){
        return {
          name: 'ProjectMessageBoard',
          params: {
            project_id: msg.projects[0].id,
          }
        };
    },
    routeToMessage(message){
      this.$router.push(this.getMessageRoute(message));
    },
    readMessageAndRoute(message){
      let self = this;
      this.requestMarkMessageAsRead({ message_id: message.id }).then( () => {
        self.$router.push(self.getMessageRoute(message));
      });
    },
    markAllAsRead(){
      this.show_mark_all_as_read_progress = true;
      this.markMessagesAsRead(JSON.parse(JSON.stringify(this.getMessagesCurrentUser)), this.getMessagesCurrentUser.length);
    },
    markMessagesAsRead(messages, init_len){
      let self = this;
      if (messages.length === 0) {
        this.show_mark_all_as_read_progress = false;
      } else {
        let msg = messages.shift();
        this.requestMarkMessageAsRead(
          { message_id: msg.id }
        ).then( () => {
          self.mark_all_as_read_progress = ((init_len - messages.length) / init_len) * 100;
          self.markMessagesAsRead(messages, init_len);
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.message-preview {
  width: 100%;
  // overflow-x: hidden;
  // text-overflow: ellipsis;
}
</style>
